"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.AccordionDetails = exports.AccordionToggle = exports.AccordionSummary = exports.AccordionWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const inventory_1 = require("../../theme/inventory");
exports.AccordionWrapper = styled_components_1.default.div`
  border-radius: 5px;
  border: 1px solid;
  border-color: ${props => props.theme.colors.gray_201};
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }

  ${props => props.stylesOverride};
`;
exports.AccordionSummary = styled_components_1.default.div`
  cursor: pointer;
  user-select: none;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  line-height: ${props => props.theme.lineHeights[19]};
  border-bottom: 1px solid transparent;

  ${props => props.expanded && (0, styled_components_1.css)`
      border-color: ${props.theme.colors.gray_201};
      font-weight: ${props.theme.fontWeights[inventory_1.GeneralFontWeights.bold]};
    `}
`;
exports.AccordionToggle = styled_components_1.default.button.attrs({
  type: 'button'
})`
  border: 0;
  background: 0;
  outline: 0;
  padding: 0;
  cursor: inherit;
  transition: transform 200ms;
  transform: rotate(-90deg);

  svg {
    transform: scale(1.25);
  }

  g {
    opacity: 1;
  }

  ${props => props.expanded && (0, styled_components_1.css)`
      transform: rotate(0);
      g {
        fill: ${props.theme.colors.primary_700_main};
      }
    `}
`;
exports.AccordionDetails = styled_components_1.default.div`
  overflow: hidden;
  height: 0;
  transition: height 0.2s, overflow 0s 0.2s;

  ${props => props.expanded && (0, styled_components_1.css)`
      height: ${props.contentHeight}px;
    `}
`;
exports.Content = styled_components_1.default.div`
  padding: 12px 12px 25px;
`;